import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  Backdrop,
  Box,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileMenuStack, setMobileMenuStack] = useState([]);
  const [syllabusData, setSyllabusData] = useState([]);
  const [timetableData, setTimetableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [syllabusRes, timetableRes] = await Promise.all([
          axios.get("https://backend-school-914b.onrender.com/syllabus"),
          axios.get("https://backend-school-914b.onrender.com/timetable"),
        ]);
        setSyllabusData(syllabusRes.data);
        setTimetableData(timetableRes.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, []);

  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
    setMobileMenuStack([]);
  };

  const navigateMobileMenu = (options) => {
    setMobileMenuStack((prev) => [...prev, options]);
  };

  const goBackMobileMenu = () => {
    setMobileMenuStack((prev) => prev.slice(0, -1));
  };

  const aboutOptions = [
    { label: "Education", path: "/education" },
    { label: "Social Service", path: "/social-service" },
    { label: "Motivation", path: "/motivation" },
    { label: "Logo", path: "/logo" },
    { label: "Future Plan", path: "/future-plan" },
  ];

  const admissionOptions = [
    { label: "Admission Procedure", path: "/admission-procedure" },
    // { label: "Rules and Regulations", path: "/rules-regulations" },
    { label: 'Admission Enquiry', path: '/admission-enquiry' },
  ];

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "Gallery", path: "/gallery" },
    { label: "About Us", dropdown: aboutOptions },
    { label: "Admission", dropdown: admissionOptions },
    { label: "Academics", path: "/academics" },
    // { label: "Syllabus", dropdown: syllabusData.map((item) => ({ label: item.class, path: item.downloadLink })) },
    // { label: "TimeTable", dropdown: timetableData.map((item) => ({ label: item.class, path: item.downloadLink })) },
    { label: "Contact Us", path: "/contact" },
    { label: "Donate Us", path: "/donate" },
  ];

  const renderMobileMenu = () => (
    <Drawer anchor="right" open={mobileOpen} onClose={toggleMobileMenu}>
      <Backdrop
        sx={{
          zIndex: 1300,
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.5rem",
        }}
        open={mobileOpen}
        onClick={toggleMobileMenu}
      >
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "10px",
            padding: "30px",
            textAlign: "center",
            animation: "fadeIn 0.5s ease-in-out",
            color: "#fff",
            backdropFilter: "blur(10px)",
            width: "80%",
            maxWidth: "400px",
            fontSize: "1.5rem",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <IconButton
            onClick={toggleMobileMenu}
            sx={{ position: "absolute", top: 20, right: 20, color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
          {mobileMenuStack.length > 0 ? (
            <>
              <Button
                sx={{
                  color: "#fff",
                  marginBottom: 2,
                  animation: "fadeIn 0.5s ease-in",
                  fontSize: "1.5rem",
                }}
                onClick={goBackMobileMenu}
              >
                Back
              </Button>
              {mobileMenuStack[mobileMenuStack.length - 1].map((option, index) => (
                <Box
                  key={option.label}
                  sx={{
                    margin: "10px 0",
                    animation: `fadeSlideIn 0.5s ease-in ${index * 0.2}s`,
                    animationFillMode: "both",
                    fontSize: "1.5rem",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontSize="1.5rem"
                    onClick={() => {
                      if (option.path) {
                        window.location.href = option.path;
                      } else if (option.dropdown) {
                        navigateMobileMenu(option.dropdown);
                      }
                    }}
                    sx={{
                      cursor: "pointer",
                      padding: "10px 20px",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "5px",
                      },
                    }}
                  >
                    {option.label}
                  </Typography>
                </Box>
              ))}
            </>
          ) : (
            menuItems.map((item, index) => (
              <Box
                key={item.label}
                sx={{
                  margin: "10px 0",
                  animation: `fadeSlideIn 0.5s ease-in ${index * 0.2}s`,
                  animationFillMode: "both",
                  fontSize: "1.5rem",
                }}
              >
                <Typography
                  variant="h6"
                  fontSize="1.5rem"
                  onClick={() => {
                    if (item.path) {
                      window.location.href = item.path;
                    } else if (item.dropdown) {
                      navigateMobileMenu(item.dropdown);
                    }
                  }}
                  sx={{
                    cursor: "pointer",
                    padding: "10px 20px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      borderRadius: "5px",
                      fontSize: "1.5rem",
                    },
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))
          )}
        </Box>
      </Backdrop>
    </Drawer>
  );

  return (
    <AppBar position="static" sx={{ backgroundColor: "#fff", padding: 1 }}>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'center' }}
        >
          <img
            src="Images/LOGO.png"
            alt="Logo"
            style={{ width: '50px', height: '50px', marginRight: 10 }}
          />
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000', textAlign: 'center' }}>
              JAMIA NIDA-E-ISLAM
            </Typography>
            {/* <Typography variant="body2" sx={{ color: '#fff', fontStyle: 'italic', textAlign: 'center' }}>
              Knowledge is Light
            </Typography> */}
          </Box>
        </Box>
        <IconButton
          color="inherit"
          edge="end"
          onClick={toggleMobileMenu}
          sx={{color: '#000'}}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
      {renderMobileMenu()}
    </AppBar>
  );
};

export default Header;
